import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Notification } from '@sleipai/sleip-models';

export type NotificationsForRecordingsUnreadState = EntityState<Notification>;

export const notificationsForRecordingsUnreadAdapter: EntityAdapter<Notification> =
  createEntityAdapter<Notification>({
    selectId: (notification: Notification) => notification.resourceId ?? notification.id ?? '',
  });

export const {
  selectIds: selectNotificationsForRecordingsUnreadIdsAdapter,
  selectEntities: selectNotificationsForRecordingsUnreadEntitiesAdapter,
  selectAll: selectAllNotificationsForRecordingsUnreadAdapter,
  selectTotal: selectNotificationsForRecordingsUnreadTotalAdapter,
} = notificationsForRecordingsUnreadAdapter.getSelectors();
